import { message, Skeleton } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Router } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { GetCampaignCounts } from '../../../apis/Brand/Campaigns/GetCampaignCounts';
import { useGlobalState } from '../../../store/state';
// import './CampaignCountsComponent.styles.scss';

const CampaignCountsComponent = () => {
  const params = useParams();
  const [user] = useGlobalState('user');
  const [loading, setLoading] = useState(true);
  const [counts, setCounts] = useState({
    assigned: 0,
    active: 0,
    review: 0,
    closed: 0,
  });
  useEffect(() => {
    GetCampaignCounts(user.accessToken, params.companyId).then(({ status, response })=>{
      if (status === 200) {
        console.log('count response', response);
        setCounts({ ...response[0] });
        setLoading(false);
      } else {
        message.error('Faild to get Campaign counts');
      }
    });
  }, [loading]);

  return (
    <div className="col-md-9 px-2">
      <div className="common_card p-3 h-100 camp_stat_counts">
        {
          !loading ? (
            <>
              <h5 className="text-left">Campaign Status</h5>
              <ul>
                <li style={{ cursor: 'pointer' }}>
                  <Link to={`/brand/${params.companyId}/campaign?status=draft`}>
                    <h6>{counts.draft || 0}</h6>
                    <p>Draft</p>
                  </Link>
                </li>
                <li style={{ cursor: 'pointer' }}>
                  <Link to={`/brand/${params.companyId}/campaign?status=review`}>
                    <h6>{counts.review || 0}</h6>
                    <p>In Review</p>
                  </Link>
                </li>
                <li style={{ cursor: 'pointer' }}>
                  <Link to={`/brand/${params.companyId}/campaign?status=published`}>
                    <h6>{counts.published || 0}</h6>
                    <p>Published</p>
                  </Link>
                </li>
                <li style={{ cursor: 'pointer' }}>
                  <Link to={`/brand/${params.companyId}/campaign?status=pendingpayment`}>
                    <h6>{counts.pendingpayment || 0}</h6>
                    <p>Awaiting Payment</p>
                  </Link>
                </li>
                <li style={{ cursor: 'pointer' }}>
                  <Link to={`/brand/${params.companyId}/campaign?status=active`}>
                    <h6>{counts.active || 0}</h6>
                    <p>Active</p>
                  </Link>
                </li>
                <li style={{ cursor: 'pointer' }}>
                  <Link to={`/brand/${params.companyId}/campaign?status=completed`}>
                    <h6>{counts.completed || 0}</h6>
                    <p>Completed</p>
                  </Link>
                </li>
              </ul>
            </>
          ):(
            <Skeleton active
              paragraph={{ rows: 1 }}/>
          )
        }
      </div>
    </div>
  );
};

export default CampaignCountsComponent;
